import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    title: {
      ...theme.eatclub.typography.cancelTitle,
      maxWidth: '700px',
    },
    mainContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '60px',
      lineHeight: '1.4',
    },
    pageContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '60px',
      fontSize: '18px',
      // maxWidth: '800px',
    },
    feeTable: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
    },
    feeTableRow: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '40px',
      maxWidth: '800px',
      padding: '0 10px',

      [theme.breakpoints.down('sm')]: {
        gap: '16px',
      },
    },
    feeRowLeft: {
      display: 'flex',
      gap: '24px',
    },
    feeRowRight: {
      display: 'flex',
      gap: '24px',

      [theme.breakpoints.down('sm')]: {
        gap: '16px',
      },
    },
    feeRowMain: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      fontSize: '18px',
      gap: '10px',
    },
    feeRowTitle: {
      fontSize: '22px',
      fontWeight: theme.fontWeights.medium,
      color: theme.colors.black,
    },
    feeRowSavings: {},
    feeRowDiscountContainer: {
      width: '120px',
      textAlign: 'left',

      [theme.breakpoints.down('sm')]: {
        width: '100px',
      },
    },
    feeRowDiscount: {
      position: 'relative',
      fontSize: '24px',
      color: theme.colors.fadedText,
      width: 'fit-content',

      '&::before': {
        content: "''",
        position: 'absolute',
        left: '4px',
        right: '4px',
        top: '0.38em',
        bottom: '10px',
        background:
          'linear-gradient(to left top, transparent 45.5%, black 47.5%, black 52.5%, transparent 54.5%)',
        pointerEvents: 'none',
      },
    },
    feeRowNewPrice: {
      color: theme.colors.black,
      fontSize: '24px',
    },
    checkMark: {
      border: '1px solid black',
      backgroundColor: theme.colors.lightYellowBackground,
      width: '40px',
      height: '35px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50px',
    },

    summary: {
      maxWidth: '670px',
      fontSize: '22px',
    },
  }),
  { name: 'ExtraWeekPage' },
);

export default useStyles;
